import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TranslocoLocaleModule } from '@ngneat/transloco-locale';
import { TranslocoModule } from '@ngneat/transloco';

import { TelusFormComponent } from './form';
import { TelusCommonModule } from '../common/common.module';
import { TerritoryFormComponent } from './territory-form/territory-form';
import { Address360FormComponent } from './address-360-form/address-360-form';
import { Address360SearchListViewFormComponent } from './address-360-list-view-form/address-360-search-list-view-form';
import { UserFormComponent } from './user-form/user-form';
import { RoleFormComponent } from './role-form/role-form';
import { SafeContentPipe } from '../pipes/safe/safe-pipe.module';
import { FilterComponent } from '../table/filter/filter';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { IonInputMaskDirective } from './ion-input-mask.directive';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    TranslocoModule,
    TelusCommonModule,
    TranslocoLocaleModule.forRoot(),
    SafeContentPipe,
    NgxMaskDirective,
    NgxMaskPipe,
  ],
  declarations: [
    IonInputMaskDirective,
    TelusFormComponent,
    TerritoryFormComponent,
    Address360FormComponent,
    Address360SearchListViewFormComponent,
    UserFormComponent,
    RoleFormComponent,
    FilterComponent,
  ],
  exports: [
    TelusFormComponent,
    TerritoryFormComponent,
    Address360FormComponent,
    Address360SearchListViewFormComponent,
    UserFormComponent,
    RoleFormComponent,
  ],
})
export class TelusFormModule {}
